// BannerSection.jsx
import React, { useEffect, useState } from "react";
import { Button, Badge, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logogg.png";
import bannerImg from "../../assets/bannerr.jpg";

const BannerSection = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [boxCount, setBoxCount] = useState(0);

  // Check token + load cart count whenever page loads or cart changes
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);

    const cartData = JSON.parse(localStorage.getItem("cartItems") || "[]");
    let total = 0;
    cartData.forEach((c) => (total += c.boxes?.length || 0));
    setBoxCount(total);
  }, []);

  const handleAuthClick = () => {
    if (isLoggedIn) {
      localStorage.removeItem("token");
      localStorage.removeItem("persist:root");
      setIsLoggedIn(false);
      navigate("/login");
    } else {
      navigate("/login");
    }
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        padding: "0 10%",
        overflow: "hidden",
        // backgroundImage: `url(${bannerImg})`,
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // backgroundAttachment: "fixed",
        zIndex: 99,  
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
      />

      {/* Top bar */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "10%",
          right: "10%",
          zIndex: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img src={logo} alt="Logo" style={{ width: "80px" , cursor: "pointer"}} onClick={() => navigate("/")} />

        <div style={{ display: "flex", gap: "15px" }}>
          {/* Login / Logout */}
          <Button type="default" style={{ borderRadius: "6px", background:"#e4b349", color:"#3c3c3be6", borderColor:"#e4b349"}} onClick={handleAuthClick}>
            {isLoggedIn ? "Logout" : "Login"}
          </Button>

          {/* My Account - visible only when logged in */}
          {isLoggedIn && (
            <Button
              type="default"
              style={{ borderRadius: "6px", background:"#3c3c3be6", border:"#3c3c3be6", color:"#fff" }}
              onClick={() => navigate("/bkdashboard")}
            >
              My Account
            </Button>
          )}

        </div>
      </div>

      {/* Banner text */}
      <Row
        gutter={[40, 40]}
        style={{ width: "100%", position: "relative", zIndex: 2, marginTop: "60px" }}
        align="middle"
      >
        <Col xs={24} md={12}>
          <h1
            style={{
              fontSize: "56px",
              fontWeight: "700",
              lineHeight: "1.3",
              color: "#fff",
              marginBottom: "10px",
            }}
          >
            Fast & Reliable Shipments
          </h1>
          <p style={{ fontSize: "20px", color: "#eee" }}>
            Track, manage, and deliver with ease.
          </p>
          <Button
            type="primary"
            size="large"
            style={{
              borderRadius: "8px",
              backgroundColor: "#e4b349",
              borderColor: "#e4b349",
              marginTop: "20px",
              padding: "15px 30px",
              fontSize: "1.3em",
              fontWeight: "600",
              color: "#3c3c3be6",
            }}
            onClick={() => navigate("/shipment")}
          >
            Create Shipment
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default BannerSection;
